import { render, staticRenderFns } from "./AllergyIntolerancesView.vue?vue&type=template&id=65d0a38e&scoped=true&"
import script from "./AllergyIntolerancesView.vue?vue&type=script&lang=ts&"
export * from "./AllergyIntolerancesView.vue?vue&type=script&lang=ts&"
import style0 from "./AllergyIntolerancesView.vue?vue&type=style&index=0&id=65d0a38e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d0a38e",
  null
  
)

export default component.exports